export default function (app) {
	app.filter('fillWithStar', function () {
		return function (input) {
			if (!input) {
				return null;
			}

			var splitted = input.split('');
			var length = splitted.length;

			for (var i = 3; i < length - 3; i++) {
				splitted[i] = '*';
			}
			return splitted.join('');
		};
	});
};
